module.exports = __webpack_public_path__ + "img/pantalla-9-6.afdc1971.png";